"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.UnsupportedBrowser = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["className", "colorSet", "children"];
var Wrapper = exports.Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnsupportedBrowser__Wrapper",
  componentId: "sc-9pnsws-0"
})(["", ";color:var(--text-base,", ");background-color:var(--background-base,", ");position:fixed;top:0;bottom:0;left:0;inline-size:100%;z-index:", ";display:flex;flex-direction:column;text-align:center;overflow:auto;", ";"], (0, _index.rootStyle)(), _index.defaultTheme.invertedDark.text.base, _index.defaultTheme.invertedDark.background.base, _index.zIndexFixed, (0, _index.overflowWrapFlexText)());
var BodyWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnsupportedBrowser__BodyWrapper",
  componentId: "sc-9pnsws-1"
})(["box-sizing:border-box;display:flex;flex-direction:column;max-inline-size:100%;max-block-size:100%;padding:", ";margin:auto;*{margin:auto;}"], (0, _index.cssSpacing)('looser', '24px'));
var BodySvg = _styledComponents["default"].svg.withConfig({
  displayName: "UnsupportedBrowser__BodySvg",
  componentId: "sc-9pnsws-2"
})(["stroke:var(--background-base,", ");margin-block-end:", ";flex-shrink:0;[dir='rtl'] &{transform:scaleX(-1);}"], _index.defaultTheme.invertedDark.background.base, (0, _index.cssSpacing)('looser-4', '64px'));
/**
 * @deprecated
 * This component is deprecated and will be archived in a future release.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-unsupportedbrowser--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/UnsupportedBrowser)
 */
var UnsupportedBrowser = exports.UnsupportedBrowser = function UnsupportedBrowser(_ref) {
  var className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'invertedDark' : _ref$colorSet,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, Object.assign({}, props, {
    className: (0, _index.addColorSet)(colorSet, className),
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.UnsupportedBrowser
  }), /*#__PURE__*/_react["default"].createElement(BodyWrapper, null, /*#__PURE__*/_react["default"].createElement(BodySvg, {
    role: "img",
    width: "214",
    height: "155",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    stroke: "#FFF",
    strokeWidth: "3",
    x: "1.5",
    y: "1.5",
    width: "211",
    height: "152",
    rx: "9"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#FFF",
    cx: "16",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#FFF",
    cx: "32",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#FFF",
    cx: "48",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4M135 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4",
    stroke: "#FFF",
    strokeWidth: "3",
    strokeLinecap: "square"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68 122.374c13-4.25 26-6.374 39-6.374s26 2.125 39 6.374M2.5 34.5h210",
    stroke: "#FFF",
    strokeWidth: "3",
    strokeLinecap: "square"
  })), children));
};